import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installChatUserIdInjector } from './services/chatUserId';

// Make the real end user id available to every /api/chat/ request so the backend
// can enforce per-user access restrictions (the app auths as the shared apiuser).
installChatUserIdInjector();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
